import { createContext, useContext } from "react";
import { BotbLeaderboardsContext } from "./types";

export const BotbLeaderboardContext = createContext<BotbLeaderboardsContext>({
  activeCompetitionsLoading: false,
  activeCompetitions: [],
  leaderboardPlayers: [],
  prizesData: [],
  isLeaderboardDataLoading: false,
  getPrize: null,
  openPrizesModal: null,
  closePrizesModal: null,
  activeTab: 0,
  setActiveTab: null,
  tournamentEndDate: 0,
  hasSubscription: false,
  youPlayer: null,
  tournamentFinished: false,
});

export const useBotbLeaderboardContext = () => useContext(BotbLeaderboardContext);
